import { defineMessage } from 'services/localization';

export const messages = {
    label: defineMessage('approval_condition_1'),
    stepTypeDefault: defineMessage('all'),
    stepTypeAnyOf: defineMessage('any_of'),
    stepTypeAnyOfCount: defineMessage('any_count_of_selected'),
};
